import React, { useEffect, useState } from "react";
import axios from 'axios';
import { API_BASE_URL } from "../../../constant/constant";
import {
  Box,
 
  Card,
  CardContent,
  Typography,
  
} from "@mui/material";
import {
  People,
  TrendingUp,
  ErrorOutline,
  
} from "@mui/icons-material";


function SP_StatCards() {


  return (
    <div>
        

<Card sx={{ p: 2, mt: 2, borderRadius: 3, boxShadow: 3 }}>
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center", // centers the items
      gap: 2, // spacing between cards
    }}
  >
    {[
      {
        title: "Total Users",
        value: "12,450",
        icon: <People fontSize="large" color="primary" />,
      },
      {
        title: "Active Sessions",
        value: "1,230",
        icon: <TrendingUp fontSize="large" color="success" />,
      },
      {
        title: "Errors",
        value: "23",
        icon: <ErrorOutline fontSize="large" color="error" />,
      },
    ].map((card) => (
      <Card
        key={card.title}
        sx={{
          borderRadius: 3,
          boxShadow: 3,
          flex: "1 1 250px", // responsive width
          maxWidth: 300,
        }}
      >
        <CardContent sx={{ display: "flex", alignItems: "center" }}>
          {card.icon}
          <Box sx={{ ml: 2 }}>
            <Typography variant="body2" color="text.secondary">
              {card.title}
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              {card.value}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    ))}
  </Box>
</Card>



    </div>
  )
}

export default SP_StatCards